<template>
  <button
    class="button"
    :class="{ gray, red, small, useClose, useArrow, fullwidth }"
    :data-analytics-linkName="linkName"
    :data-analytics-linkCategory="linkCategory"
    @click="$emit('click', $event)">
    <IconArrow class="arrow"/>
    <IconTimes class="close"/>
    <span><slot></slot></span>
  </button>
</template>

<script>
  import IconArrow from '@/assets/svg/icon-arrow-right.svg?inline';
  import IconTimes from '@/assets/svg/icon-times.svg?inline';

  export default {
    name: 'Button',
    components: {
      IconArrow,
      IconTimes,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      linkName: {
        type: String,
        default: null,
      },
      linkCategory: {
        type: String,
        default: null,
      },
      useClose: {
        type: Boolean,
        default: false,
      },
      useArrow: {
        type: Boolean,
        default: false,
      },
      red: {
        type: Boolean,
        default: false,
      },
      gray: {
        type: Boolean,
        default: false,
      },
      small: {
        type: Boolean,
        default: false,
      },
      fullwidth: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .button {
    position: relative;
    display: inline-block;
    outline: 0;
    background: $color-blue;
    border-radius: 2px;
    border: 0;
    padding: 0 16px;
    height: 46px;
    @include font-daimler-cs(400);
    font-size: 16px;
    color: $color-white;
    cursor: pointer;

    @include ie11 {
      padding: 16px 16px 8px;
    }

    svg {
      position: relative;
      margin-right: 6px;
      display: none;

      @include ie11 {
        top: 4px;
      }

      &.close {
        width: 9px;
        height: 9px;
        path { fill: $color-white; }
      }
      &.arrow {
        width: 6px;
        height: 10px;
      }
    }

    &.useArrow {
      svg.arrow {
        display: inline-block;
      }
    }
    &.useClose {
      svg.close {
        display: inline-block;
      }
    }

    &.gray {
      background: $color-gray;
    }

    &.red {
      background: $color-error;
    }

    &.small {
      height: 40px;
    }
    &.fullwidth {
      width: 100%;
    }
  }
</style>
